import SpellBlock from "../Statblock/PopupBlocks/SpellBlock.js"
import { Popover } from '@base-ui-components/react/popover';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ConditionBlock from "../Statblock/PopupBlocks/ConditionBlock.js";
import { conditionsExport, exportSpells, effectSpellMap } from '../../constants.js';

const calcSourceTitle = (title) => {
    if(title === 'XPHB')
        return '2024'

    if(title === 'PHB')
        return '2014'

    return title
}

const EffectGridPopup = ({ effectName, type='condition' }) => {

    let items;
    if(type === 'spell') {
        items = exportSpells.filter(s => s.name.toLowerCase() === effectSpellMap[effectName].toLowerCase())
    } else {
        items = conditionsExport.filter(c => c.name.toLowerCase() === effectName.toLowerCase())
    }

    return (
        <Tabs>
            <TabList className='react-tabs__tab-list spellTabTitles'>
                {items.map((item) => (
                    <Tab key={'tabTitle'+item.source+item.name}>{calcSourceTitle(item.source)}</Tab>
                ))}
            </TabList>
            {items.map((item) => (
                <TabPanel key={'tabDesc'+item.source+item.name}>
                    {type === 'spell' ? (
                        <SpellBlock spell={item} />
                    ) : (
                        // condition status disease
                        <ConditionBlock condition={item} />
                    )}
                </TabPanel>
            ))}
        </Tabs>
    )
}

export default EffectGridPopup;
